import { render } from "./MapV.vue?vue&type=template&id=bdd70a56&scoped=true"
import script from "./MapV.vue?vue&type=script&lang=js"
export * from "./MapV.vue?vue&type=script&lang=js"

import "./MapV.vue?vue&type=style&index=0&id=bdd70a56&scoped=true&lang=css"

import exportComponent from "/Users/mustafatofur/Desktop/Work/ProjectCountMap/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdd70a56"]])

export default __exports__